// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"9e2e91b6","330":"4dcc857c","411":"2443e9b8","415":"09ae2d94","480":"62ac0bab","801":"1b84baed","866":"74a9864d"}[chunkId] + ".chunk.js";
};